<div [hidden]="!loading">
  <div class="loading-spinner">
    <img src="assets/images/gif/elasbank.gif">
    <span class="loading-message">Carregando...</span>
  </div>
</div>